import { render } from "./PasswordResetApp.vue?vue&type=template&id=bf6360f4&scoped=true"
import script from "./PasswordResetApp.vue?vue&type=script&lang=js"
export * from "./PasswordResetApp.vue?vue&type=script&lang=js"

import "./PasswordResetApp.vue?vue&type=style&index=0&id=bf6360f4&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6360f4"],['__file',"src/PasswordResetApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf6360f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf6360f4', __exports__)) {
    api.reload('bf6360f4', __exports__)
  }
  
  module.hot.accept("./PasswordResetApp.vue?vue&type=template&id=bf6360f4&scoped=true", () => {
    api.rerender('bf6360f4', render)
  })

}


export default __exports__